export const DEVICE_AUTH_CODE_SESSION_KEY = 'tempDeviceAuthCode'

export const shadowSynchronizationStates = {
    UNSET: 'UNSET',
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
}

export const GITHUB_VERSION_URL = 'https://api.github.com/repos/plgd-dev/hub/releases/latest'

export const GITHUB_VERSION_REQUEST_INTERVAL = 30 // in minutes

export const CONFIGURATION_PAGE_FRAME = 'configuration-page-frame'
